// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../.0.26.4@css-loader/index.js!../../.1.3.3@postcss-loader/index.js!../../.3.0.0@less-loader/lib/loader.js!./antd.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../.0.13.2@style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../.0.26.4@css-loader/index.js!../../.1.3.3@postcss-loader/index.js!../../.3.0.0@less-loader/lib/loader.js!./antd.less", function() {
			var newContent = require("!!../../.0.26.4@css-loader/index.js!../../.1.3.3@postcss-loader/index.js!../../.3.0.0@less-loader/lib/loader.js!./antd.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/.2.9.0@antd/dist/antd.less
// module id = 210
// module chunks = 0